import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ProfileProbabilitiesPage = ({ title, buttons, plot }) => {
    const navigate = useNavigate();

    const onClick = (path) => {
        console.log(path);
        navigate(path);
    }

  return (
    <Box style={{ backgroundColor: '#F8F3EC' }} padding={4}>
        <Grid container mb={4}>
            <Grid item md={9}>
                <Typography variant="h5">{title}</Typography>
            </Grid>
            <Grid item md={3} style={{ display: 'flex', justifyContent: 'center' }}>
                <img src="Spark-Logo-sm.png" alt="Spark Interventions LLC" style={{ width: '25%', height: 'auto' }} />
            </Grid>
        </Grid>
        <Grid container>
            <Grid item xs={12} md={8} padding={4}>
                <Grid container direction="column" justifyContent="center" alignItems="center">
                    <Grid item style={{ padding: '2px' }}>
                        <Grid container direction="column" justifyContent="center" alignItems="center">
                            <Grid item>
                                <Typography variant="h6" sx={{textDecoration: 'underline'}} display="inline" align="center">Place Individuals into Profiles based on their Probability of Inclusion</Typography>
                            </Grid>
                            <Grid item>
                                    <Typography component="div" variant="body1">
                                        <ul style={{ listStyle: 'inside' }}>
                                            <li style={{ textAlign: 'center' }}>This is a visualization of the model's operation and would not usually be seen by the end-user</li>
                                            <li style={{ textAlign: 'center' }}>The model found 2 profiles</li>
                                            <li style={{ textAlign: 'center' }}>Individuals with similar performance have a probability of being in the same profile</li>
                                            <li style={{ textAlign: 'center' }}>We can create interventions based on an individual's profiles</li>
                                        </ul>
                                    </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item alignItems="center" sx={{ mt: 4 }}>
                        {buttons.map((button, index) => (
                            <Button
                            key={index}
                            variant="contained"
                            color="primary"
                            onClick={() => onClick(button.path)}
                            style={{ margin: '0 8px' }}
                            >
                                {button.label}
                            </Button>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
                <img key='plot' src={`data:image/jpeg;base64,${plot}`} alt={`Cluster probability individuals plot`} style={{ maxWidth: '100%'}} />
            </Grid>
        </Grid>
    </Box>
  );
};

export default ProfileProbabilitiesPage;
